module.exports = __webpack_public_path__ + "static/media/ban-member.3a935d52.svg";